import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    standalone: false
})
export class FileSizePipe implements PipeTransform {

  readonly kbLimit = 1024;
  readonly mbLimit = this.kbLimit * 1024;
  readonly gbLimit = this.mbLimit * 1024;
  readonly tbLimit = this.gbLimit * 1024;
  readonly pbLimit = this.tbLimit * 1024;

  readonly bUnit = 'B';
  readonly kbUnit = 'KB';
  readonly mbUnit = 'MB';
  readonly gbUnit = 'GB';
  readonly tbUnit = 'TB';
  readonly pbUnit = 'PB';

  transform(size: number) {
    if (size >= this.pbLimit) {
      return (size / (this.pbLimit)).toFixed(0) + ' ' + this.pbUnit;
    } else if (size >= this.tbLimit) {
      return (size / (this.tbLimit)).toFixed(0) + ' ' + this.tbUnit;
    } else if (size >= this.gbLimit) {
      return (size / (this.gbLimit)).toFixed(0) + ' ' + this.gbUnit;
    } else if (size >= this.mbLimit) {
      return (size / (this.mbLimit)).toFixed(0) + ' ' + this.mbUnit;
    } else if (size >= this.kbLimit) {
      return (size / (this.kbLimit)).toFixed(0) + ' ' + this.kbUnit;
    } else {
      return size + ' ' + this.bUnit;
    }
  }
}
